import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { visibilityControl } from '@/components/Cms/Card/Card.styles';
import { Flex } from '@/components/Flex';
import { theme } from '@/theme';

export const Wrapper = styled(Box)`
  height: 100px;
  padding-bottom: ${theme.space.s080};
  img {
    cursor: pointer;
  }
  .view-options {
    width: 102px;
  }
  .mobile-only {
    ${visibilityControl(false, true)};
  }
  .desktop-only {
    ${visibilityControl(true, false)};
  }
  ${({ theme }) =>
    css`
      ${theme.media.lg.up} {
        height: 80px;
      }
    `}
`;

export const InstallmentInfoSection = styled(Flex)`
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;

  ${({ theme }) => theme.media.md.up} {
    justify-content: left;
  }
`;
